import * as Dialog from '@radix-ui/react-dialog';

import { logger } from '@/lib/logger';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { FarcasterIcon } from '@/ui/Icons/FarcasterIcon';
import { ShareIcon } from '@/ui/Icons/ShareIcon';
import { TwitterIcon } from '@/ui/Icons/TwitterIcon';
import { BottomPanelModal } from '@/ui/Modal/BottomPanelModal';

import { PAGE_DESCRIPTION } from '../share';

export function ShareTxBottomPanelModal({
  isOpen,
  handleOpenChange,
  onShareOnX,
  onShareOnFarcaster,
  url,
}: {
  isOpen: boolean;
  handleOpenChange: (open: boolean) => void;
  onShareOnX: () => void;
  onShareOnFarcaster?: () => void;
  url: string;
}) {
  const onShareClick = () => {
    try {
      navigator.share({
        text: `${PAGE_DESCRIPTION}\n`,
        url: url,
      });
    } catch (error) {
      logger.error('Error sharing:', error);
    }
  };

  return (
    <BottomPanelModal
      isOpen={isOpen}
      onClose={() => handleOpenChange(false)}
      onOpenChange={handleOpenChange}
      variant="LARGE"
    >
      <div className="flex flex-col gap-3 pt-6 pb-[26px] px-4 w-full z-10">
        <Dialog.Title className={fontStyles({ variant: 'H5', class: ['pb-1'] })}>
          Share
        </Dialog.Title>

        <button
          className={buttons({
            size: 'small',
            color: 'gray',
            shape: 'pill',
            class: ['w-full', 'h-9'],
          })}
          onClick={onShareOnX}
        >
          <TwitterIcon className="mr-2" /> Share on X.com
        </button>

        {onShareOnFarcaster && (
          <button
            className={buttons({
              size: 'small',
              color: 'gray',
              shape: 'pill',
              class: ['w-full', 'h-9'],
            })}
            onClick={onShareOnFarcaster}
          >
            <FarcasterIcon className="mr-2" /> Share on Farcaster
          </button>
        )}

        <button
          className={buttons({
            size: 'small',
            color: 'gray',
            shape: 'pill',
            class: ['w-full', 'h-9'],
          })}
          onClick={onShareClick}
        >
          <ShareIcon className="mr-2" /> Share
        </button>
      </div>
    </BottomPanelModal>
  );
}
